import { Injectable } from '@angular/core';
import {
  ListCommentsRequest,
  ListTicketsRequest,
  SearchTicketsRequest,
  SortBy,
  SortOrder,
  Status,
  SupportApiService,
  Ticket,
  TicketComment,
  User,
} from './_internal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SupportService {
  constructor(private _api: SupportApiService) {}

  searchTickets(
    partnerId: string,
    term: string,
    status: Status,
    sortBy: SortBy,
    sortOrder: SortOrder,
    cursor: string,
  ): Observable<PagedResponse> {
    const req = new SearchTicketsRequest({
      partnerId: partnerId,
      searchTerm: term,
      status: status,
      sortBy: sortBy,
      sortOrder: sortOrder,
      cursor: cursor,
    });
    return this._api
      .searchTickets(req)
      .pipe(map((resp) => new PagedResponse(resp.tickets, resp.users, resp.nextCursor, resp.hasMore, resp.count)));
  }

  listTickets(partnerId: string, cursor: string): Observable<PagedResponse> {
    const req = new ListTicketsRequest({
      partnerId: partnerId,
      cursor: cursor,
    });
    return this._api
      .listTickets(req)
      .pipe(map((resp) => new PagedResponse(resp.tickets, resp.users, resp.nextCursor, resp.hasMore, resp.count)));
  }

  listComments(ticketId: number): Observable<TicketComment[]> {
    const req = new ListCommentsRequest({
      ticketId: ticketId,
    });
    return this._api.listComments(req).pipe(map((resp) => resp.comments));
  }
}

export class PagedResponse {
  tickets: Ticket[];
  users: User[];
  nextCursor: string;
  hasMore: boolean;
  count: number;

  constructor(tickets: Ticket[], users: User[], nextCursor: string, hasMore: boolean, count: number) {
    this.tickets = tickets;
    this.users = users;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
    this.count = count;
  }
}
